import PropTypes from 'prop-types'

const WavyLine = ({ stroke = 'transparent' }) => {
  // used to set the stroke color of the wave using a map (`colors[stroke] || stroke`),
  // but have dropped this due as it was based on legacy colours:
  // $colours: ('rpf-black': #000000, 'rpf-white': #ffffff, ...)
  const strokeColor = stroke
  return (
    <svg
      width="1"
      height="15"
      viewBox="0 0 650 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin slice"
    >
      <path
        d="M-38 11.0469C-30.7474 11.0469 -30.7474 3.04687 -23.4949 3.04687C-16.2423 3.04687 -16.2423 11.0469 -8.98979 11.0469C-1.73724 11.0469 -1.73724 3.04687 5.49832 3.04687C12.7511 3.04687 12.7511 11.0469 19.9864 11.0469C27.2391 11.0469 27.2391 3.04687 34.4745 3.04687C41.7272 3.04687 41.7272 11.0469 48.9794 11.0469C56.2321 11.0469 56.2321 3.04687 63.4848 3.04687C70.737 3.04687 70.737 11.0469 77.9897 11.0469C85.2424 11.0469 85.2424 3.04687 92.4951 3.04687C99.7473 3.04687 99.7473 11.0469 107 11.0469"
        stroke={strokeColor}
        strokeWidth="6"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M107 11.0469C114.253 11.0469 114.253 3.04687 121.505 3.04687C128.758 3.04687 128.758 11.0469 136.01 11.0469C143.263 11.0469 143.263 3.04687 150.498 3.04687C157.751 3.04687 157.751 11.0469 164.986 11.0469C172.239 11.0469 172.239 3.04687 179.474 3.04687C186.727 3.04687 186.727 11.0469 193.979 11.0469C201.232 11.0469 201.232 3.04687 208.485 3.04687C215.737 3.04687 215.737 11.0469 222.99 11.0469C230.242 11.0469 230.242 3.04687 237.495 3.04687C244.747 3.04687 244.747 11.0469 252 11.0469"
        stroke={strokeColor}
        strokeWidth="6"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M252 11.0469C259.303 11.0469 259.303 3.04687 266.605 3.04687C273.908 3.04687 273.908 11.0469 281.21 11.0469C288.513 11.0469 288.513 3.04687 295.798 3.04687C303.101 3.04687 303.101 11.0469 310.386 11.0469C317.689 11.0469 317.689 3.04687 324.974 3.04687C332.277 3.04687 332.277 11.0469 339.579 11.0469C346.882 11.0469 346.882 3.04687 354.185 3.04687C361.487 3.04687 361.487 11.0469 368.79 11.0469C376.092 11.0469 376.092 3.04687 383.395 3.04687C390.697 3.04687 390.697 11.0469 398 11.0469"
        stroke={strokeColor}
        strokeWidth="6"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M398 11.0469C405.253 11.0469 405.253 3.04687 412.505 3.04687C419.758 3.04687 419.758 11.0469 427.01 11.0469C434.263 11.0469 434.263 3.04687 441.498 3.04687C448.751 3.04687 448.751 11.0469 455.986 11.0469C463.239 11.0469 463.239 3.04687 470.474 3.04687C477.727 3.04687 477.727 11.0469 484.979 11.0469C492.232 11.0469 492.232 3.04687 499.485 3.04687C506.737 3.04687 506.737 11.0469 513.99 11.0469C521.242 11.0469 521.242 3.04687 528.495 3.04687C535.747 3.04687 535.747 11.0469 543 11.0469"
        stroke={strokeColor}
        strokeWidth="6"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M543 11.0469C550.253 11.0469 550.253 3.04687 557.505 3.04687C564.758 3.04687 564.758 11.0469 572.01 11.0469C579.263 11.0469 579.263 3.04687 586.498 3.04687C593.751 3.04687 593.751 11.0469 600.986 11.0469C608.239 11.0469 608.239 3.04687 615.474 3.04687C622.727 3.04687 622.727 11.0469 629.979 11.0469C637.232 11.0469 637.232 3.04687 644.485 3.04687C651.737 3.04687 651.737 11.0469 658.99 11.0469C666.242 11.0469 666.242 3.04687 673.495 3.04687C680.747 3.04687 680.747 11.0469 688 11.0469"
        stroke={strokeColor}
        strokeWidth="6"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  )
}

WavyLine.propTypes = {
  stroke: PropTypes.string,
}

export default WavyLine
